import WalletConnector from '@/src/components/AppComponents/WalletConnector/WalletConnector';
import { MAYZ_LOGO } from '@/src/utils/images';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import styles from './Menu.module.scss';
import Navigation from './Navigation';
import { useAppStore } from '@/src/store/global';

export default function Menu() {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    const [isOpen, setIsOpen] = useState<boolean>(false);
    //--------------------------------------
    const handleClickOpen = () => {
        isOpen ? setIsOpen(false) : setIsOpen(true);
    };
    //--------------------------------------
    return (
        <section className={styles.menu}>
            <div className={`${styles.btnMenu} ${isOpen ? styles.open : ''}`} onClick={handleClickOpen}>
                <div className={styles.menuLine}></div>
                <div className={styles.menuLine}></div>
                <div className={styles.menuLine}></div>
            </div>
            <div className={`${styles.menuContent} ${isOpen ? styles.open : ''}`}>
                <div className={styles.menuHead}>
                    <Image src={MAYZ_LOGO} alt="logo" width={40} height={40} className={styles.logo} />
                </div>
                <Navigation onClick={handleClickOpen} isOpen={isOpen} />
                {isRefreshing === false && appStore.isAppStoreLoading === false && <WalletConnector isMobile={true} />}
            </div>
        </section>
    );
}
